import graphql__825a4f08c78901b29ae7 from "./__generated__/CustomerAccountList_query.graphql.ts";import * as React from "react"
import {useEffect, useTransition} from "react"
import {graphql} from "react-relay";
import {usePaginationFragment} from "react-relay/hooks";
import CustomerAccountListItem from "./CustomerAccountListItem";
import LoadMoreButton from "./presentational/LoadMoreButton";
import {useIntl} from "react-intl";

type CustomerAccountListProps = {
    queryRef: any // FIXME: Any type we can define here? It's actually: Readonly<{ ' $data'?: unknown; ' $fragmentRefs': unknown; }> | null
    searchTerm?: string
    onLoadingChange?: (isLoading: boolean) => void
}

const CustomerAccountList: React.FC<CustomerAccountListProps> = (props) => {
    const intl = useIntl();
    const [isPending, startTransition] = useTransition();
    const {data, hasNext, loadNext, isLoadingNext, refetch} = usePaginationFragment(
        graphql__825a4f08c78901b29ae7,
        props.queryRef
    );

    useEffect(() => {
        // Use startTransition to keep the old data visible while loading new data
        // This prevents the Suspense fallback from showing
        startTransition(() => {
            refetch({searchTerm: props.searchTerm}, {fetchPolicy: 'store-and-network'});
        });
    }, [props.searchTerm, refetch])

    useEffect(() => {
        // Notify parent component about loading state
        props.onLoadingChange?.(isPending);
    }, [isPending, props]);

    if (!data.customerAccounts || data.customerAccounts.totalCount === 0) {
        return (<></>);
    }

    return (
        <nav className="flex-1 min-h-0 relative overflow-y-auto" aria-label={intl.formatMessage({id: 'navigation.customers'})}>
            <ul className="relative z-0 divide-y divide-gray-200">
                {data.customerAccounts.edges.map(
                    (edge, index) => {
                        return <CustomerAccountListItem key={index} customerAccount={edge.node}/>
                    }
                )}
            </ul>
            {hasNext && <LoadMoreButton onClick={() => loadNext(100)} isLoadingNext={isLoadingNext}/>}
        </nav>
    )
}

export default CustomerAccountList;
